
import {LoginData, RegisterData} from '@/api/index'


export default {
  namespaced: true,
  
}




// WEBPACK FOOTER //
// ./src/store/modules/user/uesr.js